export const PAGE_SIZE = 20;
export function nextMemberPage(last, pages) {
  if (last.length < PAGE_SIZE) return undefined;
  const old = new Set(
    pages
      .slice(0, -1)
      .flat()
      .map((u) => u.id),
  );
  return last.some((u) => !old.has(u.id)) ? pages.length + 1 : undefined;
}
export const uniqueMembers = (pages) => [
  ...new Map((pages || []).flat().map((u) => [u.id, u])).values(),
];
export function memberReason(user, t) {
  const reasons = {
    SIMILAR_TASTE: 'similarTaste',
    ACTIVE_REVIEWER: 'active',
    RISING_REVIEWER: 'rising',
    DISCOVERY_MIX: 'discovery',
  };
  if (reasons[user.recommendationReason])
    return t(`profile.recommendation.${reasons[user.recommendationReason]}`, {
      count: user.sharedRatingCount ?? 0,
    });
  const signals = [
    ['ratings', user.reviewsCount],
    ['playlists', user.playlistsCount],
    ['comments', user.commentsCount],
  ]
    .filter(([, n]) => n > 0)
    .slice(0, 2);
  return signals.length
    ? signals
        .map(([key, count]) =>
          t('profile.activitySignal', { label: t(`archive.tab.${key}`), count }),
        )
        .join(' · ')
    : t('profile.recentMusicActivity');
}
export function recommendationRequestId(viewerId, nonce, items, pageIndex) {
  let hash = 2166136261;
  items.forEach((item) => {
    for (const char of String(item.id)) {
      hash ^= char.charCodeAt(0);
      hash = Math.imul(hash, 16777619);
    }
  });
  return `reviewer-finder:v2:${viewerId}:${nonce}:p${pageIndex + 1}:${items.length}:${(hash >>> 0).toString(36)}`;
}
